// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "รหัสข้อผิดพลาด:",
    "error.search": "ค้นหาในฐานความรู้ของเราเพื่อเรียนรู้เพิ่มเติม",
    dismiss: "ปิด",
    "installation.title": "",
    "cancelation.button": "ยกเลิก",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "การเริ่มต้นล้มเหลว",
      description: "เราไม่สามารถเรนเดอร์หน้าเพจได้ โปรดติดต่อฝ่ายสนับสนุน",
    },
    "EOS-UI-UE": {
      title: "เกิดข้อผิดพลาดขึ้น",
      description: "เกิดข้อผิดพลาดขึ้น โปรดติดต่อฝ่ายสนับสนุน",
    },
    "EOS-IN-BC": {
      title: "การติดตั้งล้มเหลว",
      description:
        "เราไม่สามารถแสดงความคืบหน้าในการติดตั้งได้ โปรดติดต่อฝ่ายสนับสนุน",
    },
    "EOS-IN-UE": {
      title: "การติดตั้งล้มเหลว",
      description: "เกิดข้อผิดพลาดขึ้น โปรดติดต่อฝ่ายสนับสนุน",
    },
    "EOS-IN-FF": {
      title: "การติดตั้งล้มเหลว",
      description:
        "เราไม่สามารถเชื่อมต่อกับ Epic Online Services ได้ โปรดติดต่อฝ่ายสนับสนุน",
    },
    "EOS-IN-FF-*": {
      title: "การติดตั้งล้มเหลว",
      description:
        "เราไม่สามารถส่งคำขอไปยัง Epic Online Services ได้ โปรดติดต่อฝ่ายสนับสนุน",
    },
    fallback: {
      title: "เกิดข้อผิดพลาดขึ้น",
      description: "เกิดข้อผิดพลาดขึ้น โปรดติดต่อฝ่ายสนับสนุน",
    },
  },
};
